<template>
  <div class="about">
    <h1>{{message}}</h1>
    <!-- <button @click="callSecureApi">Call Secure API</button> -->
    <v-progress-circular color="primary" indeterminate></v-progress-circular>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
    }
  },
  computed: {
    message: function () {
      return (this.$root.isAuthenticated) ? 'You are logged in' : 'Redirecting...'
    }
  },
  methods: {
    async callSecureApi () {
      try {
        const response = await axios.get('https://localhost:44326/api/services')
        this.services = response.data
        console.log(response.data)
      } catch (err) {
        console.log('secure api call failed')
      }
    }
  }
}
</script>
